import React, { useState } from "react";

import styles from "./tab.module.css";

import ProjectTabBox from "../portfolio_box/project_tab_box";
import { projects } from '../../../../data/projects';
const TapObj = {
  0: ["#spring", "#nodejs", "#python", "#php"], // back
  1: ["#Web", "#App", "#Flutter", "#React", "#React-native", ], // front
  2: ["#데이터파이프라이닝", "#하둡", "#스파크", "#도커",], // infra
  3: ["#인공지능", "#데이터분석", "#마케팅", "#서비스"], // keyword
}

const PortfolioTabBox = (props) => {

  const [activeTab, setActiveTab] = useState(0);
  const clickHandler = (id) => {
    setActiveTab(id)
  }

  return (
    <>
      <div className={styles.wrapper}>
        <ul className={styles.tabs}>
          {TapObj[props.selected].map((data, index) => (
            <li key={data}
              className={`${activeTab === index ? `${styles.active}` : ""}`}
            >         
              <button type="button" aria-pressed={activeTab === index} onClick={() => clickHandler(index)}>{data}</button>
            </li>
          ))}
        </ul>
        <div className={styles.contents}>
          {projects.map((data) => {
            return (data.hashtag || []).includes(TapObj[props.selected][activeTab]) ? <ProjectTabBox key={data.id} variant={data} /> : null
          })}
        </div>
      </div>
    </>
  )
}

export default PortfolioTabBox;
